import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {StatusChip} from 'components/DSYS/StatusChip';
import {toCalendarDate} from 'views/admin/utils';

import {toShortDate} from './utils';

export const WorkstreamArchivedStatus = ({
  archivedAt,
  size = 'small',
}: {
  archivedAt?: string;
  size?: 'small' | 'xsmall';
}) => {
  return (
    <Box display="flex" alignItems="center" columnGap="6">
      <StatusChip status="archived" includeArchived size={size} />
      {archivedAt && (
        <Text size={size === 'small' ? 'small' : 'xsmall'} color="subtle">
          {toShortDate(toCalendarDate(archivedAt))}
        </Text>
      )}
    </Box>
  );
};
